import React from 'react';
import { arrayOf, string, bool, func } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';
import { publish } from '../utils/publisher';

const SupplementalTiles = ({
  productsData, schemaName, isDrawerShow, onClickShowDrawer
}) => {

  const handleImageClick = (idx) => publish({
    componentName: 'supplemental-recs',
    eventName: 'click',
    data: {
      position: idx + 1,
      schemaName
    }
  });

  const truncatedData = productsData?.filter((__, i) => i < 6);

  return (
    <div className="sui-grid sui-grid-cols-2 sui-gap-4 sui-mt-5 sui-ml-2">
      {
        truncatedData?.length
        && (
          <>
            {
              truncatedData.map((prod, idx) => {
                const imageUrl = prod?.product?.media?.images?.[0]?.url;
                const { productLabel } = prod?.product?.identifiers;
                const itemId = prod?.product?.itemId;

                return (
                  <div key={itemId}>
                    <meta data-prop="name" content={itemId} />
                    { isDrawerShow
                      ? (
                        <Image
                          src={imageUrl?.replace(/<SIZE>/gi, '300')}
                          lazy
                          stretchy
                          alt={productLabel}
                          title={productLabel}
                          onClick={onClickShowDrawer}
                        />
                      )
                      : (
                        <a
                          href={prod?.product?.identifiers?.canonicalUrl}
                          onClick={() => handleImageClick(idx)}
                        >
                          <Image
                            src={imageUrl?.replace(/<SIZE>/gi, '300')}
                            lazy
                            stretchy
                            alt={productLabel}
                            title={productLabel}
                          />
                        </a>
                      )}
                  </div>
                );
              })
            }
          </>
        )
      }
    </div>
  );
};

SupplementalTiles.propTypes = {
  productsData: arrayOf(Object),
  schemaName: string,
  isDrawerShow: bool,
  onClickShowDrawer: func
};

SupplementalTiles.defaultProps = {
  productsData: null,
  schemaName: '',
  isDrawerShow: null,
  onClickShowDrawer: () => {}
};

export { SupplementalTiles };